const storeName = 'address';

export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOAD_ADDRESSES: `${storeName}.LOAD_ADDRESSES`,
    LOAD_BILLING_ADDRESSES: `${storeName}.LOAD_BILLING_ADDRESSES`,
    SET_ADDRESSES: `${storeName}.SET_ADDRESSES`,
    SET_BILLING_ADDRESSES: `${storeName}.SET_BILLING_ADDRESSES`,
    SET_INITIAL: `${storeName}.SET_INITIAL`,
    SET_AS_DEFAULT: `${storeName}.SET_AS_DEFAULT`,
    SET_WAS_SHOWN_MESSAGE: `${storeName}.SET_WAS_SHOWN_MESSAGE`,
    REMOVE_MESSAGE: `${storeName}.REMOVE_MESSAGE`,
    REMOVE_ADDRESS: `${storeName}.REMOVE_ADDRESS`,
    REMOVE_WITH_CONFIRMATION: `${storeName}.REMOVE_WITH_CONFIRMATION`,
    SET_ADDRESS_TO_REMOVE: `${storeName}.SET_ADDRESS_TO_REMOVE`,
    SET_ADDRESS_BOOK_TYPE: `${storeName}.SET_ADDRESS_BOOK_TYPE`,
    OPEN_ADDRESS_BOOK: `${storeName}.OPEN_ADDRESS_BOOK`,
    SET_SELECTED_ADDRESS_ID: `${storeName}.SET_SELECTED_ADDRESS_ID`,
    SET_CURRENT_DELIVERY_ADDRESS_ID: `${storeName}.SET_CURRENT_DELIVERY_ADDRESS_ID`,
    SET_CURRENT_BILLING_ADDRESS_ID: `${storeName}.SET_CURRENT_BILLING_ADDRESS_ID`,
    CHECK_AND_VALIDATE: `${storeName}.CHECK_AND_VALIDATE`,
    SET_ADDRESS_BOOK_ERROR_MESSAGE: `${storeName}.SET_ADDRESS_BOOK_ERROR_MESSAGE`,
    SET_INVALID_ADDRESS: `${storeName}.SET_INVALID_ADDRESS`,
    RESET_ADDRESS_BOOK_DATA: `${storeName}.RESET_ADDRESS_BOOK_DATA`,
    RESET_SELECTED_ADDRESSES_AND_REDIRECT: `${storeName}.RESET_SELECTED_ADDRESSES_AND_REDIRECT`,
    SET_SELECTED_FOR_PAYMENT_ADDRESSES: `${storeName}.SET_SELECTED_FOR_PAYMENT_ADDRESSES`,
    SET_ADDRESS_FOR_PAYMENT: `${storeName}.SET_ADDRESS_FOR_PAYMENT`,
    SET_NEIGHBORHOOD_FIELD_INFO: `${storeName}.SET_NEIGHBORHOOD_FIELD_INFO`,
};
